import { render, staticRenderFns } from "./AppTrackReferralsMenu.vue?vue&type=template&id=7725b812"
import script from "./AppTrackReferralsMenu.vue?vue&type=script&lang=js"
export * from "./AppTrackReferralsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports